let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4QLof")).then(() => parcelRequire('m6YP7'));